import { h } from '../dom.js';

export interface AffiliatePayload {
  heading: string;
  disclosure: string;
  links: { label: string; url: string }[];
  advertise: { text: string; url: string | null };
}
const EMPTY: AffiliatePayload = { heading: '', disclosure: '', links: [], advertise: { text: 'Advertise here', url: null } };
let cached: Promise<AffiliatePayload> | null = null;
export function loadAffiliate(): Promise<AffiliatePayload> {
  if (!cached) {
    cached = fetch('/api/affiliate')
      .then((r) => (r.ok ? (r.json() as Promise<AffiliatePayload>) : EMPTY))
      .then((p) => ({ ...EMPTY, ...p }))
      .catch(() => EMPTY);
  }
  return cached;
}

/**
 * A quiet row of Amazon Associates links. Renders nothing at all when the server has no
 * tag configured, so the panel is safe to place anywhere.
 */
export function affiliatePanel(): HTMLElement {
  const el = h('div', { class: 'affiliate', hidden: true });
  void loadAffiliate().then((p) => {
    if (!p.links.length) return;
    el.append(
      h('div', { class: 'affiliate-heading' }, p.heading),
      h('div', { class: 'affiliate-links' }, p.links.map((l) => h('a', { href: l.url, target: '_blank', rel: 'sponsored noopener' }, l.label))),
      h('div', { class: 'affiliate-disclosure' }, p.disclosure),
    );
    el.hidden = false;
  });
  return el;
}
